import React from 'react';

const CSS = require('./BookBlockPrice.module.scss');

interface BookBlockPriceProps {
  formattedPrice: string;
  kidsForFree: boolean;
}

function BookBlockPrice({ formattedPrice, kidsForFree }: BookBlockPriceProps) {
  return (
    <div className={CSS.BookBlockPrice}>
      <span className={CSS.Price}>{formattedPrice}</span>
      <span className={CSS.PerPersonLabel}>per person</span>
    </div>
  );
}

export default BookBlockPrice;
